enum AccountAuthorizations {
  DEMO_ACCESS = "DEMO_ACCESS",
  TRIAL_ACCESS = "TRIAL_ACCESS",
  FULL_ACCESS = "FULL_ACCESS",
  TRAINING_ACCESS = "TRAINING_ACCESS",
  BYBCAT_ACCESS = "BYBCAT_ACCESS",
  EDITOR_ACCESS = "EDITOR_ACCESS",
  BYBCAT_LEGACY_DATA = "BYBCAT_LEGACY_DATA",
  CUSTOM_PLAYLISTS = "CUSTOM_PLAYLISTS",
};

export default AccountAuthorizations;